import { getPersistCheckoutFromStorage } from './storageHelpers';
import CryptoJS from 'crypto-js';

const countItemInCart = (cartItems) => cartItems.reduce((acc,cur) =>
{
 let warrantyQuantity =  cur?.warranty?.quantity;
 return acc + cur.quantity + (warrantyQuantity > 0 ? warrantyQuantity : 0)
} ,0)

export const getItemCountFromShoppingRequest = () => {
  const checkoutStorage = getPersistCheckoutFromStorage();
  let numberOfItems = 0
  if(Object.keys(checkoutStorage).length > 0 && checkoutStorage !== null) {
    const { shoppingRequest } = checkoutStorage
    numberOfItems = shoppingRequest && Object.values(shoppingRequest).length > 0
      ? shoppingRequest?.cart?.cartItems &&
      countItemInCart(shoppingRequest?.cart?.cartItems)
      : 0
  }
  return numberOfItems
}
